import React, { useContext, useState } from "react";
import BackTool from "../../components/Toolnav/BackTool";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router";
import { handleDeleteOutline, handleFetchCourse } from "../../api/course";
import { AiOutlineDelete, AiOutlinePlus } from "react-icons/ai";
import { AuthContext } from "../../contexts/AuthContext";
import AssignInstructor from "./components/AssignInstructor";
import AddOutline from "./components/AddOutline";
import placeholder from "../../assets/images/placeholder.png";
import UploadThumbnail from "./components/UploadThumbnail";
import { message } from "antd";
import AssignWishlist from "./components/AssignWishlist";
import UpdateCourse from "./components/UpdateCourse";
import { FiEdit } from "react-icons/fi";
import { level2, level3 } from "../../utils/access";
export default function OneCourse() {
  const [instructorModal, setInstructorModal] = useState<boolean>(false);
  const [wishlistModal, setWishlistModal] = useState<boolean>(false);
  const [outlineModal, setOutlineModal] = useState<boolean>(false);
  const [updateModal, setUpdateModal] = useState<boolean>(false);
  const [thumbnailModal, setThumbnailModal] = useState<boolean>(false);
  const { auth } = useContext(AuthContext);
  const { id } = useParams();
  const queryClient = useQueryClient();

  const { data: course } = useQuery({
    queryKey: ["courses", id],
    queryFn: () => handleFetchCourse({ _id: id }),
  });

  const { mutate } = useMutation({
    mutationFn: handleDeleteOutline,
    onSuccess: () => {
      message.success("Removed Successfully");
      queryClient.invalidateQueries({ queryKey: ["courses", id] });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const deleteOutline = async ({ item }: any) => {
    const data = { outline: item };
    await mutate({ data, course_id: id });
  };

  return (
    <div className="">
      <BackTool />
      <div className="m-2 p-2 bg-white border">
        <div className="border-b py-2 mb-2 flex justify-between">
          <div className="">
            <span className="font-bold">Course:</span> {course?.payload?.name}
          </div>
          <div className="">
            {level2?.includes(auth?.role) && (
              <button
                onClick={() => setUpdateModal(true)}
                className="flex justify-center items-center text-xs border py-1 px-2"
              >
                <span className="mr-1">
                  <FiEdit />
                </span>
                Update
              </button>
            )}
          </div>
        </div>
        <div className="grid grid-cols-12 gap-x-2">
          <div className="col-span-12 md:col-span-4 lg:col-span-4">
            <button
              onClick={() => {
                if (level2?.includes(auth?.role)) {
                  setThumbnailModal(true);
                }
              }}
              className="bg-white border h-auto"
            >
              <img
                src={course?.payload?.thumbnail?.url || placeholder}
                alt=""
              />
            </button>
            <div className="py-2">
              <div className="text-lg border-b flex justify-between pb-2">
                <div className="">Course Outline</div>
                {level2?.includes(auth?.role) && (
                  <button
                    onClick={() => setOutlineModal(true)}
                    className="flex justify-center items-center text-xs border py-1 px-2"
                  >
                    <span className="mr-1">
                      <AiOutlinePlus />
                    </span>
                    Add Outline
                  </button>
                )}
              </div>

              <div className="mt-2">
                {course?.payload?.outline?.map((item: any, index: number) => {
                  return (
                    <div
                      className="flex items-center justify-between mb-1"
                      key={index}
                    >
                      <div className="flex items-center ml-2">
                        <div className="w-10">{index + 1}.</div>
                        <div className="">{item}</div>
                      </div>
                      <div className="">
                        {level2?.includes(auth?.role) && (
                          <button
                            onClick={() => deleteOutline({ item })}
                            className="flex justify-center items-center text-xs border py-1 px-2 hover:bg-red-100"
                          >
                            <span className="mr-1">
                              <AiOutlineDelete />
                            </span>
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="col-span-12 md:col-span-8 lg:col-span-8">
            <div className="mb-2 font-bold">Description</div>
            <div className="text-gray-500">{course?.payload?.description}</div>

            <div className="">
              <div className="flex justify-between pt-4 pb-2 border-b-4 mb-2">
                <div className="font-bold">Instructors</div>
                <div className="">
                  {level2?.includes(auth?.role) && (
                    <button
                      onClick={() => setInstructorModal(true)}
                      className="flex justify-center items-center text-xs border py-1 px-2"
                    >
                      <span className="mr-1">
                        <AiOutlinePlus />
                      </span>
                      Add Instructor
                    </button>
                  )}
                </div>
              </div>
              <div className="">
                <div className="">
                  <div className="mb-8">
                    <div className="border-t border-r border-l border-b-4 flex justify-between items-center">
                      <div className="flex">
                        <div className="w-12 p-2 border-r">S/N</div>
                        <div className="w-72 p-2 border-r">NAME</div>
                        <div className="w-72 p-2">EMAIL</div>
                      </div>
                      <div className="w-48 p-2 border-l">MOBILE</div>
                    </div>
                    {course?.payload?.instructors?.map(
                      (item: any, index: number) => (
                        <div
                          className="flex justify-between border text-gray-600 text-sm"
                          key={index}
                        >
                          <div className="flex">
                            <div className="w-12 border-r p-2 text-center">
                              {index + 1}
                            </div>
                            <div className="w-72 border-r p-2">
                              {item?.name}
                            </div>
                            <div className="w-72 p-2">{item?.email}</div>
                          </div>
                          <div className="w-48 p-2 border-l">
                            {item?.mobile}
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="">
              <div className="flex justify-between pt-4 pb-2 border-b-4 mb-2">
                <div className="font-bold">Wishlist</div>
                <div className="">
                  {level3?.includes(auth?.role) && (
                    <button
                      onClick={() => setWishlistModal(true)}
                      className="flex justify-center items-center text-xs border py-1 px-2"
                    >
                      <span className="mr-1">
                        <AiOutlinePlus />
                      </span>
                      Add Wishlist
                    </button>
                  )}
                </div>
              </div>
              <div className="mb-8">
                <div className="border-t border-r border-l border-b-4 flex justify-between items-center">
                  <div className="flex">
                    <div className="w-12 p-2 border-r">S/N</div>
                    <div className="w-72 p-2 border-r">NAME</div>
                    <div className="w-72 p-2">EMAIL</div>
                  </div>
                  <div className="w-48 p-2 border-l">MOBILE</div>
                </div>
                {course?.payload?.wishList?.map((item: any, index: number) => (
                  <div
                    className="flex justify-between border text-gray-600 text-sm"
                    key={index}
                  >
                    <div className="flex">
                      <div className="w-12 border-r p-2 text-center">
                        {index + 1}
                      </div>
                      <div className="w-72 border-r p-2">{item?.name}</div>
                      <div className="w-72 p-2">{item?.email}</div>
                    </div>
                    <div className="w-48 p-2 border-l">{item?.mobile}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <AssignInstructor
        isVisible={instructorModal}
        setVisible={setInstructorModal}
        course_id={id}
      />
      <AssignWishlist
        isVisible={wishlistModal}
        setVisible={setWishlistModal}
        course_id={id}
      />

      <UpdateCourse
        isVisible={updateModal}
        setVisible={setUpdateModal}
        course_id={id}
        course={course?.payload}
      />
      <AddOutline
        isVisible={outlineModal}
        setVisible={setOutlineModal}
        course_id={id}
        course={course}
      />
      <UploadThumbnail
        isVisible={thumbnailModal}
        setVisible={setThumbnailModal}
        course_id={id}
      />
    </div>
  );
}
